import { AlgoliaSearch } from "@/services/algoliaSearch"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const querySuggestedAlgoliaArticles = {
  async suggestedAlgoliaArticles(_parent, args, context, _info) {
    const { searchTerm, branchId } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ARTICLES,
      operation: Operations.READ,
    })

    if (!searchTerm || searchTerm.length === 0) return null

    const algoliaClient = AlgoliaSearch.client()
    const articlesResponse = await algoliaClient.searchSingleIndex({
      indexName: "articles",
      searchParams: {
        query: searchTerm,
        clickAnalytics: true,
        hitsPerPage: 7,
        ...(branchId?.length > 0 && {
          filters: `NOT notAvailableInBranchOffices:${branchId}`,
        }),
      },
    })

    if (!articlesResponse || articlesResponse.hits.length === 0) {
      throw new Error("No articles found")
    }

    const articleSuggestions = articlesResponse.hits.map((hit) => ({
      sku: hit.sku,
      title: hit.title,
      altTitle: hit.altTitle,
      amountContainerContents: hit.amountContainerContents,
    }))

    return articleSuggestions
  },
}
